import React, { useEffect, useState } from 'react'
import './index.scss'
import EarnTime from '@/components/earntime'
import DEarnShow from './dearnshow'
import {driverMoney} from '@/utils/drivermoney'
import {dayInConmeListApi} from '@/api'
const DayEarn = () => {
  //今日在线时长、收益、每笔收益详情
  let [todayIncome, setTodayIncome] = useState(0)
  let [todayOnline, setTodayOnline] = useState(0)
  let [incomeDetail, setIncomeDetail] = useState([])
  useEffect(() => {
    //请求当日流水
    driverMoney(dayInConmeListApi,{queryDate:''})
      .then((d) => {
        if (d.data.data) {
          if (d.data.data.todayIncome) {
            setTodayIncome(d.data.data.todayIncome)
          }
          if (d.data.data.todayOnline) {
            setTodayOnline(d.data.data.todayOnline)
          }
          if(d.data.data.incomeDetail) {
            setIncomeDetail(d.data.data.incomeDetail)
          }
        }

      })
    return () => {

    }
  }, [])
  return (
    <div className="day-earn__box">
      {/* 传递今日收益，今日在线 */}
      <EarnTime timeFrame="今日" income={todayIncome} online={todayOnline} />
      <div className="earn-con__show">
        <DEarnShow incomeDetail={incomeDetail} setTodayIncome={setTodayIncome} setTodayOnline={setTodayOnline} setIncomeDetail ={setIncomeDetail}/>
      </div>
    </div>
  )
}
export default DayEarn